import { render, staticRenderFns } from "./SkeletonLoaded.vue?vue&type=template&id=73167d01&"
import script from "./SkeletonLoaded.vue?vue&type=script&lang=js&"
export * from "./SkeletonLoaded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports